<template>
    <div class="sencond">
        <!--  <div class="notice-box">
            <el-image class="img" :src="require('@/assets/images/icon-notice.png')"></el-image>
            <span>以下结果包含会员卡 248.00元，是否计入营业收入？</span>
            <div class="radio-box">
                <el-radio v-model="radio" label="1">计入</el-radio>
                <el-radio v-model="radio" label="2">不计入</el-radio>
            </div>

        </div> -->
        <div class="grid-list">
            <div class="grid-content">
                <div>
                    收款合计(元)
                </div>
                <div>
                    {{ dataInfo.totalAmount }}
                </div>
            </div>
            <div class="grid-content">
                <div>
                    营业收入(元)
                </div>
                <div>
                    {{ dataInfo.businessIncome }}
                </div>
            </div>
            <div class="grid-content">
                <div>
                    会员充值(元)
                </div>
                <div>
                    {{ dataInfo.storedAmount }}
                </div>
            </div>
            <div class="grid-content">
                <div>
                    挂账还款(元)
                </div>
                <div>
                    {{ dataInfo.pendAmount }}
                </div>
            </div>

        </div>
        <el-card class="box-card">
            <div class="header-box">
                <el-image class="img" :src="require('@/assets/images/icon-report.png')"></el-image>
                <span>
                    收款构成
                </span>
            </div>
            <div>
                <el-table :data="tableData" style="width: 98%" border>
                    <el-table-column prop="payTypeName" label="结账方式" align="center"></el-table-column>
                    <el-table-column prop="businessAmount" label="收款合计(元)" align="center"></el-table-column>
                    <el-table-column prop="businessIncome" label="营业收入(元)" align="center"></el-table-column>
                    <el-table-column prop="storeAmount" label="会员充值(元)" align="center"></el-table-column>

                </el-table>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    props: {
        dateTime: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            radio: '1',
            tableData: [],
            dataInfo: {}
        };
    },
    methods: {
        async getData() {
            let startTime = null
            let endTime = null
            if (this.dateTime.length > 0) {
                startTime = this.dateTime[0]
                endTime = this.dateTime[1]
            }
            let params = {
                startTime: startTime,
                endTime: endTime,
                merchantCode: localStorage.getItem('merchantCode')
            }
            let res = await this.$http.post('/businessOverview/payStatistics', params)
            if (res.data.code == 200) {
                this.dataInfo = res.data.data
            }
            let res2 = await this.$http.post('/businessOverview/payCompose', params)
            if (res2.data.code == 200) {
                this.tableData = res2.data.data
            }
        }
    },
    mounted() {
        this.getData()
    },
    watch: {
        dateTime: {
            handler(val) {
                this.getData()
            }
        }
    }
};
</script>

<style scoped lang="scss">
.sencond {
    width: 100%;
    height: 100%;
    background-color: #FFF;
    margin: 20px auto;

    .notice-box {
        width: 100%;
        height: 90%;
        display: flex;
        justify-content: start;
        align-items: center;
        border: 1px solid #E5E5E5;
        border-radius: 4px;
        padding: 10px 20px;

        .img {
            width: 16px;
            height: 16px;
        }

        span {
            font-size: 14px;
            color: #333;
        }

        .radio-box {
            display: flex;
            align-items: center;
            margin-left: 20px;
        }
    }

    .grid-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        gap: 20px;
        width: 98%;

        .grid-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: start;
            height: 100px;
            border: 1px solid #ccc;
            border-radius: 5px;
            padding-left: 20px;

            div:nth-child(1) {
                font-size: 16px;
                color: #999;
            }

            div:nth-child(2) {
                font-size: 28px;
                color: #333;
            }
        }
    }

    .box-card {
        width: 100%;
        min-height: 400px;
        margin-top: 20px;
        padding: 10px 20px;

        .header-box {
            display: flex;
            align-items: center;
            justify-content: start;
            margin-bottom: 20px;

            .img {
                width: 16px;
                height: 16px;
            }

            span {
                font-size: 16px;
                color: #333;
                margin-left: 10px;
            }
        }
    }


}

/deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #f59a23;
    /* 设置激活状态的边框颜色 */
    background-color: #f59a23;
    /* 设置激活状态的背景颜色 */
    color: #f59a23;
}

/deep/.el-radio__input.is-checked+.el-radio__label {
    color: #f59a23;
    /* 设置激活状态的字体颜色 */
}
</style>